import { render, staticRenderFns } from "./view-file.vue?vue&type=template&id=21e187af&scoped=true&"
import script from "./view-file.vue?vue&type=script&lang=js&"
export * from "./view-file.vue?vue&type=script&lang=js&"
import style0 from "./view-file.vue?vue&type=style&index=0&id=21e187af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e187af",
  null
  
)

export default component.exports